import React from "react";
import { dateFormatter } from "../../../components/tables/table";

const SupplierTypeContent = ({ supplierType }) => {
	if (!supplierType) return <></>;
	return (
		<>
			<div className="row d-flex align-items-center">
				<div className="col-12">
					<h5>Descripción</h5>
					<p>{supplierType?.descripcion}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col">
					<h5>Fecha Alta</h5>
					<p>{dateFormatter(supplierType?.fecha_alta) + "h"}</p>
				</div>
			</div>
		</>
	);
};

export default SupplierTypeContent;
